<div class="flex flex-col gap-4 max-w-xl w-full">
  <div class="flex items-center justify-between pb-3 border-b border-neutral-3">
    <div class="flex items-center gap-3">
      <div
        class="size-10 rounded-xl bg-primary-9/10 text-primary-11 flex items-center justify-center shrink-0"
      >
        <mat-icon class="text-xl!">event</mat-icon>
      </div>
      <div>
        <h2 class="text-base font-bold text-neutral-12 m-0">Visite du bien</h2>
        @if (data.property; as prop) {
          <p class="text-xs text-neutral-10 m-0">
            {{ prop.presentation.title || prop.location.address.city }}
          </p>
        }
      </div>
    </div>
    <button
      type="button"
      mat-icon-button
      class="text-neutral-10 hover:text-neutral-12 -mr-2"
      (click)="close()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <etxe-discussion-visit-card
    [appointment]="data.appointment"
    [application]="data.application"
    [isOwner]="data.isOwner"
    [property]="data.property"
    (proposeVisit)="onProposeVisit()"
    (confirmSlot)="onConfirmSlot($event)"
    (requestReschedule)="onRequestReschedule($event)"
    (markAsVisited)="onMarkAsVisited()"
    (reportNoShow)="onReportNoShow($event)"
  />
</div>
